import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

/* eslint-disable-next-line max-len */
const dummyText = `Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.`;
/* eslint-disable-next-line max-len */
const croppedDummyText = ` Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore...`;
/* eslint-disable-next-line max-len */
const shortDummyText = ` Lorem ipsum dolor sit amet, consetetur sadipscing elitr `;

describe("text-lines-limit", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-text-lines-limit></ux-text-lines-limit>`);
        const el = await page.find("ux-text-lines-limit");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-text-lines-limit></ux-text-lines-limit>`);
        const el = await page.find("ux-text-lines-limit");
        expect(el).toMatchSnapshot();
    });

    it("should crop the text of the component", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-text-lines-limit text-lines="1">
                <div class="text-container">
                    ${dummyText}
                </div>
            </ux-text-lines-limit>
        `);
        await page.waitForChanges();
        const textContainer = await page.find(".text-container");
        expect(textContainer.innerHTML).toBe(croppedDummyText);
    });

    it("should add a read more button", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-text-lines-limit text-lines="1" read-more-text="read more">
                <div class="text-container">
                    ${dummyText}
                </div>
            </ux-text-lines-limit>
        `);
        await page.waitForChanges();
        const textContainer = await page.find(".text-container");
        const readMoreButton = await page.find(`button[data-ux-text-lines-limit="read-more"`);
        expect(textContainer.innerHTML).not.toBe(dummyText);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        expect(readMoreButton).toBeTruthy;
        await readMoreButton.click();
        await page.waitForChanges();
        expect(textContainer.innerHTML).toBe(` ${dummyText} `);
    });

    it("should not add a read more button", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-text-lines-limit text-lines="1" read-more-text="read more">
                <div class="text-container">
                    ${shortDummyText}
                </div>
            </ux-text-lines-limit>
        `);
        await page.waitForChanges();
        const textContainer = await page.find(".text-container");
        expect(textContainer.innerHTML).toBe(shortDummyText);
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-text-lines-limit></ux-text-lines-limit>`);
    });
});
